module.exports = __webpack_public_path__ + "static/media/whatsappBroadcast.mobile.0c62c1f9.svg";